import { render } from "./CourseListItem.vue?vue&type=template&id=2d28a811&ts=true"
import script from "./CourseListItem.vue?vue&type=script&lang=ts"
export * from "./CourseListItem.vue?vue&type=script&lang=ts"

import "./CourseListItem.vue?vue&type=style&index=0&id=2d28a811&lang=css"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__